var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.plan
    ? _c("div", { staticClass: "account-cards__item" }, [
        _c("div", { staticClass: "account__heading" }, [
          _vm._v(" " + _vm._s(_vm.$t("account.subscription.title")) + " ")
        ]),
        _c("div", { staticClass: "account-block" }, [
          _c("span", { staticClass: "account__subtitle" }, [
            _vm._v(" " + _vm._s(_vm.$t("subscription.plans.planType")) + " ")
          ]),
          !_vm.plan.editorAccess
            ? _c("span", { staticClass: "account__text" }, [
                _vm._v(_vm._s(_vm.$t("subscription.plans.noPlan")))
              ])
            : _vm.plan.editorAccess
            ? _c("span", { staticClass: "account__text" }, [
                _vm._v(_vm._s(_vm.$t(`subscription.plans.${_vm.plan.type}`)))
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "account__link" }, [
          _vm.account && _vm.account.stripeCustomerId
            ? _c("a", { on: { click: _vm.launchCustomerPortal } }, [
                _vm._v(_vm._s(_vm.$t("actions.changePlan")))
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }